document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.shopify-policy__body .rte > p').forEach((paragraph) => {
        const text = paragraph.textContent.trim();
            if (text && text.length <= 80 && text === text.toUpperCase() && /[A-Z]/.test(text)) {
                  paragraph.classList.add('policy-section-heading');
                      }
                        });
                        });

const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '1X', 'XXL', '2X', '2XL', 'XXXL', '3X', '3XL', '4X', '4XL', '5X', '5XL'];
const sizeRank = new Map(sizeOrder.map((size, index) => [size, index]));

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-size-selector="true"]').forEach((select) => {
    const placeholder = Array.from(select.options).find((option) => option.value === '');
    const sizeOptions = Array.from(select.options).filter((option) => option.value !== '');
    sizeOptions.sort((first, second) => {
      const firstRank = sizeRank.get(first.dataset.sizeValue.trim().toUpperCase()) ?? Number.MAX_SAFE_INTEGER;
      const secondRank = sizeRank.get(second.dataset.sizeValue.trim().toUpperCase()) ?? Number.MAX_SAFE_INTEGER;
      return firstRank - secondRank;
    });
    sizeOptions.forEach((option) => select.appendChild(option));
    if (placeholder) select.insertBefore(placeholder, select.firstChild);
  });
});

const productSequenceKey = (value) => {
  const url = new URL(value, window.location.origin);
  const productMarker = '/products/';
  const productIndex = url.pathname.indexOf(productMarker);
  if (productIndex === -1) return null;
  const variant = url.searchParams.get('variant');
  return `${url.pathname.slice(productIndex)}${variant ? `?variant=${variant}` : ''}`;
};

const productSequenceHref = (value) => {
  const destination = new URL(value, window.location.origin);
  const current = new URL(window.location.href);
  current.searchParams.forEach((parameterValue, parameterName) => {
    if (parameterName !== 'variant' && !destination.searchParams.has(parameterName)) {
      destination.searchParams.set(parameterName, parameterValue);
    }
  });
  return `${destination.pathname}${destination.search}`;
};

document.addEventListener('DOMContentLoaded', () => {
  const collectionPage = document.querySelector('.collection-page');
  if (collectionPage) {
    const items = Array.from(collectionPage.querySelectorAll('.product-card[href]'))
      .map((card) => productSequenceKey(card.href))
      .filter(Boolean);
    if (items.length > 1) {
      sessionStorage.setItem('mayme-product-sequence', JSON.stringify(items));
    }
  }

  const navigation = document.querySelector('[data-product-sequence]');
  if (!navigation) return;

  let items;
  try {
    items = JSON.parse(sessionStorage.getItem('mayme-product-sequence') || '[]');
  } catch {
    items = [];
  }
  if (!Array.isArray(items) || items.length < 2) return;

  const currentKey = productSequenceKey(window.location.href);
  let currentIndex = items.indexOf(currentKey);
  if (currentIndex === -1 && currentKey) {
    const currentPath = currentKey.split('?')[0];
    currentIndex = items.findIndex((item) => item.split('?')[0] === currentPath);
  }
  if (currentIndex === -1) return;

  const previous = navigation.querySelector('[data-product-sequence-previous]');
  const next = navigation.querySelector('[data-product-sequence-next]');
  if (previous && currentIndex > 0) {
    previous.href = productSequenceHref(items[currentIndex - 1]);
  } else if (previous) {
    previous.hidden = true;
  }
  if (next && currentIndex < items.length - 1) {
    next.href = productSequenceHref(items[currentIndex + 1]);
  } else if (next) {
    next.hidden = true;
  }
  navigation.hidden = Boolean(previous?.hidden && next?.hidden);

  document.addEventListener('keydown', (event) => {
    if (
      event.defaultPrevented ||
      event.repeat ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')
    ) {
      return;
    }

    const target = event.target;
    if (
      target instanceof Element &&
      target.closest('a, button, input, textarea, select, [contenteditable="true"], [role="slider"], [role="tab"], [role="option"], dialog, [popover]')
    ) {
      return;
    }

    const destination = event.key === 'ArrowLeft' ? previous : next;
    if (!(destination instanceof HTMLAnchorElement) || destination.hidden || destination.getAttribute('href') === '#') {
      return;
    }

    event.preventDefault();
    window.location.assign(destination.href);
  });
});
                        
                        document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const root = select.closest('[data-product-root]');
  const price = root && root.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  const inventoryBadge = root && root.querySelector('[data-inventory-badge]');
  if (inventoryBadge) {
    const available = Boolean(select.value) && option.dataset.available === 'true';
    const tracked = option.dataset.inventoryManagement === 'shopify';
    const stopsAtZero = option.dataset.inventoryPolicy === 'deny';
    const quantity = Number.parseInt(option.dataset.inventoryQuantity, 10);
    const threshold = Number.parseInt(inventoryBadge.dataset.threshold, 10);
    if (select.value && !available) {
      inventoryBadge.textContent = inventoryBadge.dataset.soldOutLabel;
      inventoryBadge.hidden = false;
    } else if (available && tracked && stopsAtZero && quantity > 0 && quantity <= threshold) {
      inventoryBadge.textContent = inventoryBadge.dataset.limitedLabel;
      inventoryBadge.hidden = false;
    } else {
      inventoryBadge.hidden = true;
    }
  }
  const button = select.form && select.form.querySelector('[data-add-to-bag]');
  const confirmation = select.form && select.form.querySelector('[data-bag-confirmation]');
  if (button) {
    const available = Boolean(select.value) && option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
  }
  if (confirmation) confirmation.hidden = true;
  if (select.dataset.reloadVariant === 'true') {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.location.assign(url.toString());
  }
});

const updateCartCount = async () => {
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count ? `(${cart.item_count})` : '';
    });
  } catch {
    return;
  }
};

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-ajax-cart-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-to-bag]');
  const confirmation = form.querySelector('[data-bag-confirmation]');
  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = form.dataset.addingLabel;
  confirmation.hidden = true;
  let response;
  try {
    const addUrl = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
    response = await fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Cart request failed');
    await response.json();
    await updateCartCount();
    confirmation.textContent = form.dataset.addedMessage;
    confirmation.classList.remove('is-error');
    confirmation.hidden = false;
  } catch {
    if (!response) {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    confirmation.textContent = form.dataset.errorMessage;
    confirmation.classList.add('is-error');
    confirmation.hidden = false;
  } finally {
    const select = form.querySelector('[data-variant-select]');
    const selectedOption = select && select.options[select.selectedIndex];
    button.disabled = Boolean(select && (!select.value || selectedOption.dataset.available !== 'true'));
    button.textContent = originalLabel;
  }
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-lightbox-src]');
  if (!trigger) return;
  const dialog = document.createElement('dialog');
  dialog.className = 'image-lightbox';
  dialog.innerHTML = `<button type="button" aria-label="Close">×</button><img src="${trigger.dataset.lightboxSrc}" alt="">`;
  document.body.appendChild(dialog);
  dialog.addEventListener('click', (click) => { if (click.target === dialog || click.target.closest('button')) { dialog.close(); dialog.remove(); } });
  dialog.showModal();
});

const privateListKey = 'mayme-stella-private-list-v1';

const readPrivateList = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(privateListKey) || '[]');
    return Array.isArray(saved) ? saved : [];
  } catch {
    return [];
  }
};

const writePrivateList = (items) => {
  localStorage.setItem(privateListKey, JSON.stringify(items));
};

const privateListItemKey = (item) => `${item.productId}:${item.variantId}`;

const updatePrivateListUI = () => {
  const items = readPrivateList();
  const keys = new Set(items.map(privateListItemKey));
  document.querySelectorAll('[data-private-list-count]').forEach((count) => {
    count.textContent = items.length ? ` (${items.length})` : '';
  });
  document.querySelectorAll('[data-private-list-button]').forEach((button) => {
    const key = `${button.dataset.productId}:${button.dataset.variantId}`;
    const saved = keys.has(key);
    const title = button.dataset.productTitle;
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${title} ${saved ? 'from' : 'to'} your Private List`);
    const label = button.querySelector('.private-list-button__label');
    if (label) label.textContent = saved ? 'Saved to Private List' : 'Save to Private List';
  });
};

const renderPrivateList = () => {
  const page = document.querySelector('[data-private-list-page]');
  if (!page) return;
  const grid = page.querySelector('[data-private-list-grid]');
  const empty = page.querySelector('[data-private-list-empty]');
  const items = readPrivateList();
  grid.replaceChildren();
  empty.hidden = items.length > 0;
  items.forEach((item) => {
    const shell = document.createElement('article');
    shell.className = 'product-card-shell private-list-item';
    const link = document.createElement('a');
    link.className = 'product-card product-card--seamless';
    link.href = item.url;
    const imageWrap = document.createElement('div');
    imageWrap.className = 'product-image-wrap';
    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      imageWrap.append(image);
    }
    const meta = document.createElement('div');
    meta.className = 'product-meta';
    const title = document.createElement('span');
    title.textContent = item.title;
    const price = document.createElement('span');
    price.textContent = item.price;
    meta.append(title, price);
    link.append(imageWrap, meta);
    const remove = document.createElement('button');
    remove.className = 'private-list-button private-list-button--card is-saved';
    remove.type = 'button';
    remove.dataset.privateListButton = '';
    remove.dataset.productId = item.productId;
    remove.dataset.variantId = item.variantId;
    remove.dataset.productHandle = item.handle;
    remove.dataset.productTitle = item.title;
    remove.dataset.productUrl = item.url;
    remove.dataset.productPrice = item.price;
    remove.dataset.productImage = item.image;
    remove.setAttribute('aria-pressed', 'true');
    remove.setAttribute('aria-label', `Remove ${item.title} from your Private List`);
    remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7.5 4.5h9v14.7L12 16.1l-4.5 3.1V4.5Z"/></svg><span class="private-list-button__label">Saved to Private List</span>';
    shell.append(link, remove);
    grid.append(shell);
  });
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-private-list-button]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const item = {
    productId: button.dataset.productId,
    variantId: button.dataset.variantId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    price: button.dataset.productPrice,
    image: button.dataset.productImage
  };
  const key = privateListItemKey(item);
  const items = readPrivateList();
  const existingIndex = items.findIndex((saved) => privateListItemKey(saved) === key);
  if (existingIndex >= 0) items.splice(existingIndex, 1);
  else items.unshift(item);
  writePrivateList(items);
  renderPrivateList();
  updatePrivateListUI();
});

document.addEventListener('DOMContentLoaded', () => {
  renderPrivateList();
  updatePrivateListUI();
});
